"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const imgixUrlBuilder = require("imgix-url-builder");
const isFilled = require("./isFilled.cjs");
const asImageSrc = (field, config = {}) => {
  if (field && isFilled.imageThumbnail(field)) {
    return imgixUrlBuilder.buildURL(field.url, config);
  } else {
    return null;
  }
};
exports.asImageSrc = asImageSrc;
//# sourceMappingURL=asImageSrc.cjs.map
